import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { cadastrarCaixa } from "services/api";
// import { set } from "zod";
import 'styles/cadastrarCaixa.css'
import { BtnVoltarHome } from "app/componentes/BtnVoltarHome";

export const CadastrarCaixa = () => {


    const [cod_identificacao, setCodIdentificacao] = useState("");
    const [descricao, setDescricao] = useState("");
    const [altura, setAltura] = useState<number | "">("");
    const [largura, setLargura] = useState<number | "">("");
    const [comprimento, setComprimento] = useState<number | "">("");
    // const [peso, setPeso] = useState<number | "">("");
    const [loading, setLoading] = useState(false);
    const [, setErro] = useState<string | null>(null);
    const [, setOk] = useState<string | null>(null);

    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setErro(null);
        setOk(null);

        if (!cod_identificacao || !descricao || !altura || !largura || !comprimento) {
            setErro("Preencha todos os campos.");
            return;
        }

        setLoading(true);
        // Aqui você pode fazer a chamada para a API para cadastrar a caixa

        try {
            const payload = {
                cod_identificacao: cod_identificacao.trim(),
                descricao: descricao.trim(),
                altura: Number(altura),
                largura: Number(largura),
                comprimento: Number(comprimento),
            };

            const res = await cadastrarCaixa(payload);
            console.log("Caixa cadastrada com sucesso:", res.data);
            navigate("/caixas")
            setOk("Caixa cadastrada com sucesso!");
        } catch (error) {
            setErro("Erro ao cadastrar caixa: " + error);
        }finally{
            setLoading(false);
        }
    }

    return (
        <div className="cadastro-pagina" id="page-cadastrar-caixa">
            <div className="cadastro-cartao" id="card-cadastrar-caixa">
                <header className="cadastro-topo">
                    <h1 className="cadastro-titulo">Cadastrar Caixa</h1>
                    <p className="cadastro-subtitulo">Preencha todos os campos obrigatórios.</p>
                </header>

                <form id="form-cadastrar-caixa" className="cadastro-form duas-colunas" onSubmit={handleSubmit}>
                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="campo-cod">Código de Identificação</label>
                        <input
                            id="campo-cod"
                            className="cadastro-entrada"
                            type="text"
                            placeholder="Ex.: CX-0001"
                            value={cod_identificacao}
                            onChange={(e) => setCodIdentificacao(e.target.value)}
                            required
                        />
                    </div>

                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="campo-desc">Descrição</label>
                        <input
                            id="campo-desc"
                            className="cadastro-entrada"
                            type="text"
                            placeholder="Ex.: Caixa de peças — Depósito A"
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            required
                        />
                    </div>

                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="campo-altura">Altura (cm)</label>
                        <input
                            id="campo-altura"
                            className="cadastro-entrada"
                            type="number"
                            placeholder="Ex.: 30,5"
                            value={altura}
                            onChange={(e) => setAltura(e.target.value === "" ? "" : Number(e.target.value))}
                            min={0}
                            max={10000}
                            step="0.01"
                            required
                            inputMode="decimal"
                        />
                    </div>

                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="campo-largura">Largura (cm)</label>
                        <input
                            id="campo-largura"
                            className="cadastro-entrada"
                            type="number"
                            placeholder="Ex.: 45"
                            value={largura}
                            onChange={(e) => setLargura(e.target.value === "" ? "" : Number(e.target.value))}
                            min={0}
                            max={10000}
                            step="0.01"
                            required
                            inputMode="decimal"
                        />
                    </div>

                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="campo-comprimento">Comprimento (cm)</label>
                        <input
                            id="campo-comprimento"
                            className="cadastro-entrada"
                            type="number"
                            placeholder="Ex.: 60"
                            value={comprimento}
                            onChange={(e) => setComprimento(e.target.value === "" ? "" : Number(e.target.value))}
                            min={0}
                            max={10000}
                            step="0.01"
                            required
                            inputMode="decimal"
                        />
                    </div>

                    <div className="cadastro-acoes">
                        <button id="btn-cadastrar" className="botao botao--primario" type="submit">
                            Cadastrar
                        </button>
                        <button id="btn-voltar"className="botao botao--fantasma" type="button" onClick={() => navigate(-1)}>
                            {loading ? "Cadastrando..." : "Voltar"}
                        </button>

                    </div>
                </form>
            </div>
            <BtnVoltarHome />
        </div>
    );

}